import {
  radioUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../../utils/imports';

const TITLE_TEXT = content['household-info--marital-status-title'];
const DESC_TEXT = content['household-info--marital-status-description'];
const INPUT_LABEL = content['household-info--marital-status-label'];

const { maritalStatus } = FULL_SCHEMA.definitions;
const SCHEMA_LABELS = Object.fromEntries(
  maritalStatus.enum.map(key => [key, key]),
);

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, DESC_TEXT),
    maritalStatus: radioUI({
      title: INPUT_LABEL,
      labels: SCHEMA_LABELS,
    }),
  },
  schema: {
    type: 'object',
    required: ['maritalStatus'],
    properties: { maritalStatus },
  },
};
